module.exports = __webpack_public_path__ + "static/codelounge-logo-111089999ba9944b80d67bfa83337fcd.png";